import { EditorialPageHero } from "@/components/sections/EditorialPageHero";
import { useParams, Navigate } from "@/lib/router-compat";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Check, ShoppingCart, Target, TrendingUp, Users } from "lucide-react";
import { Link } from "@/lib/router-compat";
import { Breadcrumbs } from "@/components/shared/Breadcrumbs";

interface CityData {
  name: string;
  province: string;
  description: string;
  population: string;
  keywords: string[];
}

export const citiesData: Record<string, CityData> = {
  'madrid': {
    name: 'Madrid',
    province: 'Madrid',
    description: 'el mayor mercado eCommerce de España',
    population: '3.3 millones',
    keywords: ['SEO eCommerce Madrid', 'posicionamiento tienda online Madrid', 'SEO Shopify Madrid']
  },
  'barcelona': {
    name: 'Barcelona',
    province: 'Barcelona',
    description: 'el hub de comercio electrónico del Mediterráneo',
    population: '1.6 millones',
    keywords: ['SEO eCommerce Barcelona', 'optimización tienda online Barcelona', 'SEO PrestaShop Barcelona']
  },
  'valencia': {
    name: 'Valencia',
    province: 'Valencia',
    description: 'motor comercial de la costa mediterránea',
    population: '800 mil',
    keywords: ['SEO eCommerce Valencia', 'posicionamiento tienda online Valencia', 'SEO WooCommerce Valencia']
  },
  'sevilla': {
    name: 'Sevilla',
    province: 'Sevilla',
    description: 'centro comercial del sur de España',
    population: '690 mil',
    keywords: ['SEO eCommerce Sevilla', 'optimización tienda online Sevilla', 'marketing eCommerce Sevilla']
  },
  'bilbao': {
    name: 'Bilbao',
    province: 'Vizcaya',
    description: 'referente del comercio digital en el norte',
    population: '345 mil',
    keywords: ['SEO eCommerce Bilbao', 'posicionamiento tienda online Bilbao', 'SEO Shopify Bilbao']
  },
  'toledo': {
    name: 'Toledo',
    province: 'Toledo',
    description: 'centro histórico con un comercio digital en pleno crecimiento',
    population: '85 mil',
    keywords: ['SEO eCommerce Toledo', 'posicionamiento tienda online Toledo', 'agencia SEO eCommerce Toledo']
  },
  'guadalajara': {
    name: 'Guadalajara',
    province: 'Guadalajara',
    description: 'polo logístico y comercial del Corredor del Henares',
    population: '87 mil',
    keywords: ['SEO eCommerce Guadalajara', 'posicionamiento tienda online Guadalajara', 'SEO Shopify Guadalajara']
  },
  'avila': {
    name: 'Ávila',
    province: 'Ávila',
    description: 'mercado local con gran potencial de venta online',
    population: '57 mil',
    keywords: ['SEO eCommerce Ávila', 'posicionamiento tienda online Ávila', 'agencia SEO eCommerce Ávila']
  },
  'segovia': {
    name: 'Segovia',
    province: 'Segovia',
    description: 'ciudad con comercio tradicional listo para digitalizar',
    population: '51 mil',
    keywords: ['SEO eCommerce Segovia', 'posicionamiento tienda online Segovia', 'SEO WooCommerce Segovia']
  },
  'cuenca': {
    name: 'Cuenca',
    province: 'Cuenca',
    description: 'provincia con oportunidades únicas en comercio electrónico',
    population: '54 mil',
    keywords: ['SEO eCommerce Cuenca', 'posicionamiento tienda online Cuenca', 'agencia SEO eCommerce Cuenca']
  },
  'granada': {
    name: 'Granada',
    province: 'Granada',
    description: 'capital cultural con un eCommerce en expansión',
    population: '232 mil',
    keywords: ['SEO eCommerce Granada', 'posicionamiento tienda online Granada', 'SEO PrestaShop Granada']
  },
  'leon': {
    name: 'León',
    province: 'León',
    description: 'referente comercial del noroeste con potencial digital',
    population: '122 mil',
    keywords: ['SEO eCommerce León', 'posicionamiento tienda online León', 'agencia SEO eCommerce León']
  },
  'valladolid': {
    name: 'Valladolid',
    province: 'Valladolid',
    description: 'motor económico de Castilla y León',
    population: '298 mil',
    keywords: ['SEO eCommerce Valladolid', 'posicionamiento tienda online Valladolid', 'SEO Shopify Valladolid']
  },
  'asturias': {
    name: 'Asturias',
    province: 'Asturias',
    description: 'comunidad con comercio digital en plena expansión',
    population: '1 millón',
    keywords: ['SEO eCommerce Asturias', 'posicionamiento tienda online Asturias', 'agencia SEO eCommerce Asturias']
  },
  'malaga': {
    name: 'Málaga',
    province: 'Málaga',
    description: 'hub tecnológico y turístico de la Costa del Sol',
    population: '580 mil',
    keywords: ['SEO eCommerce Málaga', 'posicionamiento tienda online Málaga', 'SEO PrestaShop Málaga']
  },
  'zamora': {
    name: 'Zamora',
    province: 'Zamora',
    description: 'provincia con oportunidades sin explotar en venta online',
    population: '60 mil',
    keywords: ['SEO eCommerce Zamora', 'posicionamiento tienda online Zamora', 'agencia SEO eCommerce Zamora']
  },
  'lugo': {
    name: 'Lugo',
    province: 'Lugo',
    description: 'mercado gallego con potencial de crecimiento digital',
    population: '98 mil',
    keywords: ['SEO eCommerce Lugo', 'posicionamiento tienda online Lugo', 'agencia SEO eCommerce Lugo']
  },
  'murcia': {
    name: 'Murcia',
    province: 'Murcia',
    description: 'región agroindustrial con eCommerce en auge',
    population: '460 mil',
    keywords: ['SEO eCommerce Murcia', 'posicionamiento tienda online Murcia', 'SEO WooCommerce Murcia']
  },
  'zaragoza': {
    name: 'Zaragoza',
    province: 'Zaragoza',
    description: 'nudo logístico clave para el eCommerce en España',
    population: '680 mil',
    keywords: ['SEO eCommerce Zaragoza', 'posicionamiento tienda online Zaragoza', 'SEO Shopify Zaragoza']
  },
  'alicante': {
    name: 'Alicante',
    province: 'Alicante',
    description: 'capital turística y comercial de la costa levantina',
    population: '337 mil',
    keywords: ['SEO eCommerce Alicante', 'posicionamiento tienda online Alicante', 'SEO PrestaShop Alicante']
  },
};

export default function SeoEcommerceCiudad() {
  const { ciudad } = useParams<{ ciudad: string }>();
  const ciudadLower = ciudad?.toLowerCase();
  const cityData = ciudadLower ? citiesData[ciudadLower] : null;

  if (!cityData) {
    return <Navigate to="/servicios/seo-ecommerce-ia" replace />;
  }

  // Normaliza la URL a minúsculas para evitar canibalización
  if (ciudad !== ciudadLower) {
    return <Navigate to={`/servicios/seo-ecommerce/${ciudadLower}`} replace />;
  }

  return (
    <>

      <div className="min-h-screen flex flex-col bg-seo-dark text-white">
        <Navbar />
        
        <main className="flex-grow pt-24">
          <div className="container mx-auto px-4 md:px-6">
            <Breadcrumbs items={[
              { label: 'Servicios', path: '/mas-servicios' },
              { label: 'SEO eCommerce', path: '/servicios/seo-ecommerce-ia' },

              { label: cityData.name, path: `/servicios/seo-ecommerce/${ciudad}` }
            ]} />
          </div>
          
          <EditorialPageHero
            kicker={`SEO Ecommerce · ${cityData.name}`}
            eyebrow="1 cliente por sector y zona"
            title={<>Cada ficha que no posiciona es una venta que pierdes.</>}
            highlight="Cada día."
            lead={`Posicionamos tiendas online en ${cityData.name} para que cada producto sea encontrado por clientes que buscan comprar.`}
            description={`Agencia especializada en SEO eCommerce en ${cityData.description}. Exclusividad por sector y zona: no trabajamos con tiendas competidoras en el mismo nicho.`}
            primaryCta={{ label: `Solicitar análisis de mi tienda en ${cityData.name}`, href: "/agenda-consultoria" }}
            secondaryCta={{ label: "WhatsApp directo", href: "https://wa.me/34910626684" }}
            note="Solo trabajamos con tiendas que facturen al menos 5.000€/mes · Compromiso mínimo 6 meses"
            video={false}
          />


          {/* Stats Section */}
          <section className="py-16 bg-seo-card/50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                <div className="text-center">
                  <div className="text-4xl font-bold text-seo-bright mb-2">{cityData.population}</div>
                  <div className="text-gray-400">Compradores Potenciales</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-seo-bright mb-2">+500%</div>
                  <div className="text-gray-400">Aumento en Ventas</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-seo-bright mb-2">ROI 8x</div>
                  <div className="text-gray-400">Retorno de Inversión</div>
                </div>
              </div>
            </div>
          </section>

          {/* Benefits Section */}
          <section className="py-16">
            <div className="container mx-auto px-4 md:px-6">
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                ¿Por qué nuestro SEO eCommerce en <span className="text-gradient">{cityData.name}</span>?
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
                <div className="bg-seo-card p-6 rounded-xl">
                  <Target className="w-12 h-12 text-seo-bright mb-4" />
                  <h3 className="text-xl font-bold mb-2">Especialización eCommerce</h3>
                  <p className="text-gray-400">
                    Expertos en todas las plataformas: Shopify, PrestaShop, WooCommerce.
                  </p>
                </div>
                
                <div className="bg-seo-card p-6 rounded-xl">
                  <TrendingUp className="w-12 h-12 text-seo-bright mb-4" />
                  <h3 className="text-xl font-bold mb-2">Aumento de Ventas</h3>
                  <p className="text-gray-400">
                    Incrementa conversiones y facturación de tu tienda en {cityData.name}.
                  </p>
                </div>
                
                <div className="bg-seo-card p-6 rounded-xl">
                  <Users className="w-12 h-12 text-seo-bright mb-4" />
                  <h3 className="text-xl font-bold mb-2">Tráfico de Compra</h3>
                  <p className="text-gray-400">
                    Atrae visitantes con intención de compra real.
                  </p>
                </div>
                
                <div className="bg-seo-card p-6 rounded-xl">
                  <Check className="w-12 h-12 text-seo-bright mb-4" />
                  <h3 className="text-xl font-bold mb-2">Optimización Continua</h3>
                  <p className="text-gray-400">
                    Mejora constante con IA y análisis de datos.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Services Section */}
          <section className="py-16 bg-seo-card/30">
            <div className="container mx-auto px-4 md:px-6">
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                Servicios SEO eCommerce en {cityData.name}
              </h2>
              
              <div className="max-w-3xl mx-auto space-y-6">
                {[
                  'Optimización de fichas de producto con IA',
                  'Estructura de categorías SEO-friendly',
                  'Keyword Research con intención de compra para ' + cityData.name,
                  'Optimización de imágenes y Rich Snippets',
                  'Link Building especializado en eCommerce',
                  'Mejora de velocidad y Core Web Vitals',
                  'Estrategia de contenidos para blog de tienda',
                  'Seguimiento de conversiones y ROI'
                ].map((service, index) => (
                  <div key={index} className="flex items-start bg-seo-card p-6 rounded-lg">
                    <Check className="w-6 h-6 text-seo-bright mr-4 flex-shrink-0 mt-1" />
                    <span className="text-lg text-gray-300">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-16">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-seo-blue/20 to-seo-purple/20 p-12 rounded-2xl border border-seo-blue/30">
                <h2 className="text-3xl md:text-4xl font-bold mb-6">
                  ¿Tu competencia ya nos ha llamado?
                </h2>
                <p className="text-xl text-gray-300 mb-8">
                  Solo trabajamos con un cliente por sector y zona en {cityData.name}. 
                  Si tu plaza sigue libre, no lo estará por mucho tiempo.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/agenda-consultoria">
                    <Button size="lg" className="bg-seo-blue hover:bg-seo-blue/80 text-white">
                      Solicitar análisis de mi tienda online en {cityData.name} →
                    </Button>
                  </Link>
                  <a href="https://wa.me/34910626684" target="_blank" rel="noopener noreferrer">
                    <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10">
                      Contactar por WhatsApp
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
        
        <Footer />
      </div>
    </>
  );
}
